import 'bootstrap'

function handleVideoModalEvents() {
  const videoModalElement = document.getElementById('videoModal')
  const videoModalContentElement = document.getElementById('videoModalContent')

  if (videoModalElement && videoModalContentElement) {
    videoModalElement.addEventListener('show.bs.modal', event => {
      const relatedTarget = event.relatedTarget
      switch (relatedTarget.dataset.videoHost) {
        case 'youtube':
          if (relatedTarget.dataset.videoPlaylist === "true") {
            videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/videoseries?list=${relatedTarget.dataset.videoId}&controls=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
          } else {
            videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/${relatedTarget.dataset.videoId}?controls=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
          }
          break
        default:
          console.warn(`Video host '${relatedTarget.dataset.videoHost}' not supported.`)
          break
      }
    })

    videoModalElement.addEventListener('hidden.bs.modal', event => {
      videoModalContentElement.innerHTML = ''      
    })
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  handleVideoModalEvents()
})